import {NgModule} from '@angular/core';
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {TareaDocumentoPageComponent} from "./components/tarea-documento-page/tarea-documento-page.component";
import {TareaDocumentoCreateComponent} from "./components/tarea-documento-create/tarea-documento-create.component";
import {CommonModule} from "@angular/common";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import {FlexModule} from "@angular/flex-layout";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatTableModule} from "@angular/material/table";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatMenuModule} from "@angular/material/menu";
import {EvkDiligenciaRespuestaComponent} from "./components/evk-diligencia-respuesta/evk-diligencia-respuesta.component";

@NgModule({
    declarations: [
        TareaDocumentoPageComponent,
        TareaDocumentoCreateComponent,
        EvkDiligenciaRespuestaComponent
    ],
    imports: [
        CommonModule,
        MatTooltipModule,
        MatButtonModule,
        FlexModule,
        MatPaginatorModule,
        MatTableModule,
        MatProgressBarModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIconModule,
        MatMenuModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatInputModule,
        FlexModule
    ],
    exports: [
        TareaDocumentoCreateComponent,
        TareaDocumentoPageComponent,
        EvkDiligenciaRespuestaComponent
    ],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'es-MX'},
        {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: 'es-MX'}
    ]
})
export class DiligenciaModule {

}
